import template from "./quote-template-create-overwrite-modal.html";

const QuoteTemplateCreateOverwriteModalComponent = {
  bindings: {
    resolve: "<",
    close: "&",
    dismiss: "&",
  },
  template: template,
  controller: class QuoteTemplateCreateOverwriteModalController {
    /* @ngInject */
    constructor(
      $rootScope,
      $q,
      $filter,
      QuoteTemplate,
      SweetAlertService,
      Notification
    ) {
      this.$rootScope = $rootScope;
      this.$q = $q;
      this.$filter = $filter;
      this.QuoteTemplate = QuoteTemplate;
      this.SweetAlertService = SweetAlertService;
      this.NotificationService = Notification;
    }

    $onInit() {
      this.quoteId = this.resolve.quoteId;
      this.loadingCustomTemplate = false;
      this.quoteCustomTemplates = [];
      this._refreshQuoteTemplates();
    }

    getTemplateFirstBackground(quoteTemplate) {
      const sectionsWithImages = quoteTemplate.sections.filter(
        (section) => section.style.backgroundImage
      );

      if (sectionsWithImages.length > 0) {
        return {
          "background-image": `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3) ), url(${sectionsWithImages[0].style.backgroundImage})`,
        };
      } else {
        let backgroundColor;
        switch (quoteTemplate.sections[0].style.backgroundColorType) {
          case "primary":
            backgroundColor =
              this.$rootScope.organization.branding.header1.color;
            break;
          case "secondary":
            backgroundColor =
              this.$rootScope.organization.branding.header2.color;
            break;
          case "none":
            backgroundColor = "#FFFFFF00";
            break;
          case "custom":
            backgroundColor = quoteTemplate.sections[0].style.backgroundColor;
            break;
        }
        return { "background-color": backgroundColor };
      }
    }

    async save(name) {
      const quoteTemplate = await this.QuoteTemplate.create(name, this.quoteId);
      if (!quoteTemplate) return;

      this.NotificationService.success({
        title: this.$filter("trans")("notificationService.title.success"),
        message: this.$filter("trans")(
          "notificationService.message.quoteTemplateSaved"
        ),
      });
      this.close({ $value: quoteTemplate });
    }

    async overWriteQuoteTemplate(quoteCustomTemplate) {
      if (!(await this.SweetAlertService.confirmationOverWriteQuoteTemplate()))
        return;

      const quoteTemplate = await this.QuoteTemplate.overwrite(
        quoteCustomTemplate._id,
        this.quoteId
      );
      if (!quoteTemplate) return;

      this.NotificationService.success({
        title: this.$filter("trans")("notificationService.title.success"),
        message: this.$filter("trans")(
          "notificationService.message.quoteTemplateUpdated"
        ),
      });
      this.close({ $value: quoteTemplate });
    }

    close() {
      this.dismiss({ $value: "cancel" });
    }

    _refreshQuoteTemplates() {
      this.loadingCustomTemplate = true;

      this.$q.all({
        customTemplatesPromise: this.QuoteTemplate.query().then(
          (customTemplatesPromise) => {
            this.quoteCustomTemplates = customTemplatesPromise;
            this.loadingCustomTemplate = false;
          }
        ),
      });
    }
  },
};

export default QuoteTemplateCreateOverwriteModalComponent;
